import { render } from "./Home.vue?vue&type=template&id=4628bafe&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=4628bafe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4628bafe"

export default script